<template>
	<div>
		<div class="card p-0">
		<div class="card-header text-center">
			<h3>Verkäufer-Einstellungen</h3>
		</div>
			<div style="max-height: 80vh; overflow-y: auto;">
				<table class="table table-hover table-striped mb-0">
					<thead class="thead-light">
						<tr>
							<th>Marktplatz</th>
							<th>min. Zuschlag</th>
							<th>Änderungspreispuffer</th>
							<th>Versandkosten</th>
							<th>Auswahllogik</th>
							<th>Preislogik</th>
							<th title="Prioritäten für Direkt-Updates">Prioritäten für Api-Update
								<i
									class="bi bi-info-circle cursor-pointer ml-1"
									role="button"
									title="Info"
									@click="$bvModal.show('priorities-info-modal')"
								></i>
							</th>
							<th>CPT aktiv</th>
							<th>Metriken aktiv</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(marketplace) in sortedMarketplaces" :key="marketplace">
							<td >{{ marketplace }}</td>
							<!-- Min Surcharge -->
							<td v-if="typeof sellerSettingsData[marketplace].minSurcharge === 'object'">
								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].minSurcharge))" :key="id">
									{{ id }} : {{ sellerSettingsData[marketplace].minSurcharge[id] }}
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
							<td v-else>
								{{ sellerSettingsData[marketplace].minSurcharge }}
							</td>
							<!-- Repricing Buffer -->
							<td v-if="typeof sellerSettingsData[marketplace].repricingBuffer === 'object'">

								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].repricingBuffer))" :key="id">
									{{ id }} : {{ sellerSettingsData[marketplace].repricingBuffer[id] }}
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
							<td v-else>
								{{ sellerSettingsData[marketplace].repricingBuffer }}
							</td>
							<!-- Shipping Cost -->
							<td v-if="typeof sellerSettingsData[marketplace].shippingCost === 'object'">
								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].shippingCost))" :key="id">
									{{ id }} : {{ sellerSettingsData[marketplace].shippingCost[id] }}
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
							<td v-else>
								{{ sellerSettingsData[marketplace].shippingCost }}
							</td>
							<!-- Selection Logic -->
							<td v-if="typeof sellerSettingsData[marketplace].selectionLogic === 'object'">
								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].selectionLogic))" :key="id">
									{{ id }} : {{ translations[sellerSettingsData[marketplace].selectionLogic[id]] }}
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
							<td v-else>
								{{ sellerSettingsData[marketplace].selectionLogic }}
							</td>
							<!-- Pricing Logic -->
							<td v-if="typeof sellerSettingsData[marketplace].pricingLogic === 'object'">
								<template
										v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].pricingLogic))"
										:key="id"
								>
									{{ id }} : {{ translations[sellerSettingsData[marketplace].pricingLogic[id]] }}
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
							<td v-else>
								{{ sellerSettingsData[marketplace].pricingLogic }}
							</td>
							<!-- Priorities for Direct Update -->
							<td v-if="sellerSettingsData[marketplace].priorities">

								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].priorities))" :key="id">
									{{ id }} : {{ sellerSettingsData[marketplace].priorities[id]?.length > 0 ?
										sellerSettingsData[marketplace].priorities[id].join(', ')
										: '-' }}
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
							<td v-else>
								-
							</td>

							<!-- competetive threshhold -->
							<td v-if="typeof sellerSettingsData[marketplace].useCompetitivePriceThreshold === 'object'">

								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].useCompetitivePriceThreshold))" :key="id">
									{{ id }} :
									<i v-if="sellerSettingsData[marketplace].useCompetitivePriceThreshold[id]" class="bi bi-check-circle text-success"></i>
									<i v-else class="bi bi-x-circle text-danger"></i>
									<br v-if="index < valid.length - 1" />
								</template>
							</td>

							<!-- Metrics Active -->

							<td v-if="typeof sellerSettingsData[marketplace].metricsActive === 'object'">

								<template v-for="(id, index) in (valid = validSellerIdentifiers(sellerSettingsData[marketplace].metricsActive))" :key="id">
									{{ id }} :
									<i v-if="sellerSettingsData[marketplace].metricsActive[id]" class="bi bi-check-circle text-success"></i>
									<i v-else class="bi bi-x-circle text-danger"></i>
									<br v-if="index < valid.length - 1" />
								</template>
							</td>
						</tr>
					</tbody>
				</table>
				<b-modal id="priorities-info-modal" size="sm" hide-header hide-footer>
						<b-table
									small
									striped
									bordered
									:items="commandPriorityTranslation()"
									:fields="priorityTableFields"
							>
						</b-table>
				</b-modal>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SellerSettingsTable",
	props: {
		passedSellerSettingsData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			sellerSettingsData : this.passedSellerSettingsData,
			sellerIdentifiers: ['MUL', 'COS', 'LDD', 'WRM'],
			translations: {
				best : "Beste",
				fastest : "Schnellste",
				// ------
				lowestOnly: "Nur Niedrigster",
				lowestAndBuyBoxPrice: "Niedrigster und BuyBox Preis",
			},
			priorityTableFields: [
				{ key: 'number', label: 'Nr.' },
				{ key: 'translation', label: 'Beschreibung' },
			],
			commandPriorityTranslation() {
				return [
					{ number: 0, command: "DEL_COMMAND", translation: "Listing löschen" },
					{ number: 1, command: "ADD_WAREHOUSE", translation: "Listing hinzufügen (Lager)" },
					{ number: 2, command: "MOD_RESTOCK_QTY", translation: "Restock ab Menge kleiner 5" },
					{ number: 3, command: "MOD_LOWER_PRICE_MM_HAS_SALE", translation: "Unterbieten (mit Verkauf)" },
					{ number: 4, command: "MOD_LOWER_PRICE_MM_NO_SALE", translation: "Unterbieten (ohne Verkauf)" },
					{ number: 5, command: "MOD_LOWER_PRICE_FROM_GS_WAREHOUSE", translation: "Preis verringern bei min+30 / max (Lager)" },
					{ number: 6, command: "MOD_HIGHER_PRICE_GS_GT_5", translation: "Preis erhöhen bei min+30 / max (>5%)" },
					{ number: 7, command: "MOD_DELIVERY_DOWN_URGENT", translation: "LK auf 1 oder Prime aktivieren" },
					{ number: 8, command: "MOD_DELIVERY_DOWN_STRICT", translation: "LK verbessern (von >3 auf ≤3)" },
					{ number: 9, command: "MOD_PRIME_LOSS", translation: "Prime-Fähigkeit entfernt" },
					{ number: 10, command: "MOD_DELIVERY_UP", translation: "LK stark erhöhen (1–3 → 4+)" },
					{ number: 11, command: "MOD_HIGHER_PRICE_MM", translation: "Hochziehen" },
					{ number: 12, command: "MOD_LOWER_PRICE_GS_GT_5", translation: "Preis verringern bei min+30 / max (>5%)" },
					{ number: 13, command: "ADD_NON_BOOK", translation: "Listing hinzufügen (Non-Book Vendor)" },
					{ number: 14, command: "ADD_BOOK", translation: "Listing hinzufügen (Book Vendor)" },
					{ number: 15, command: "MOD_DELIVERY_DOWN_OTHER", translation: "LK verbessern (sonstige Fälle)" },
					{ number: 16, command: "MOD_DELIVERY_UP_OTHER", translation: "LK erhöhen (sonstige Fälle)" },
					{ number: 17, command: "MOD_LOWER_QTY", translation: "Menge verringern" },
					{ number: 18, command: "MOD_HIGHER_QTY", translation: "Menge erhöhen" },
					{ number: 19, command: "MOD_HIGHER_PRICE_FROM_GS_LE_5", translation: "Preis erhöhen bei min+30 / max (≤5%)" },
					{ number: 20, command: "MOD_LOWER_PRICE_FROM_GS_LE_5", translation: "Preis verringern bei min+30 / max (≤5%)" },
					{ number: 10000, command: "DEFAULT", translation: "Standard" },
				];
			},
		};
	},
	watch: {
		passedSellerSettingsData: {
			handler(newData) {
				console.log("Aktualisierte Verkäufer-Einstellungen:", newData);
				this.sellerSettingsData = newData;
			},
			deep: true,
		},
	},
	computed: {
		sortedMarketplaces() {
			return Object.keys(this.sellerSettingsData).sort((a, b) => a.localeCompare(b));
		},
	},
	methods: {
		validSellerIdentifiers(selectionLogic) {
			return this.sellerIdentifiers.filter(id => selectionLogic[id] != null);
		},
	},
}

</script>

<style scoped>
td, th {
	vertical-align: middle;
	text-align: center;
}

thead {
	position: sticky;
	top: 0;
	z-index: 1; /* Ensure it stays above other content */
	background-color: #f8f9fa; /* Optional: Set a background color to avoid transparency */
}
</style>